import globals from "web/script/modules/globals";

// https://github.com/alex-cory/use-ssr/blob/master/useSSR.ts
export function canUseDOM(): boolean {
    return !!(
        typeof globals.window !== "undefined" &&
        globals.window.document &&
        globals.window.document.createElement
    );
}
